import { render, staticRenderFns } from "./SolicitarConfiguracao.vue?vue&type=template&id=ea45ca94"
import script from "./SolicitarConfiguracao.vue?vue&type=script&lang=js"
export * from "./SolicitarConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports